export default "__VITE_ASSET__BTCAwY4l__"